import * as RoleType from "../../../../constants/user/RoleType"
import BlogSettingFormItem from "../BlogSettingFormItem"
import BlogInfoForm from "./BlogInfoForm"
import BlogAddressForm from "./BlogAddressForm"
import BlogCustomDomainForm from "./BlogCustomDomainForm"
import BlogEtcForm from "../BlogEtcForm"
import ManageDataForm from "../ManageDataForm"
import React from "react"

export default function({role}) {
  const canManageData = RoleType.canAccess(RoleType.convertStringToRoleType(role), RoleType.OWNER)
  return (
    <div className="blog_manage">
      <BlogSettingFormItem title='블로그 설정'>
        <BlogInfoForm />
      </BlogSettingFormItem>

      <BlogSettingFormItem title='주소 설정'>
        <BlogAddressForm />
      </BlogSettingFormItem>

      <BlogSettingFormItem title='개인 도메인 설정'>
        <BlogCustomDomainForm />
      </BlogSettingFormItem>

      <BlogSettingFormItem title='기타 설정'>
        <BlogEtcForm />
      </BlogSettingFormItem>

      { canManageData && <ManageDataForm /> }
    </div>
  )
}
